/**
 * "Encuentra tu pala" - test interactivo (modal) para PadelHouse (tema Horizon).
 *
 * Vanilla JS, sin dependencias.
 *
 * 2026-08-12: el formulario del resultado YA NO es solo localStorage. Crea el
 * cliente en Shopify con consentimiento explicito y lo etiqueta con las
 * respuestas (quiz-nivel-*, quiz-estilo-*, ...), que es lo que alimenta el
 * flow de recomendacion por correo.
 *
 * IMPORTANTE (fix 2026-07-27): el preview de resultados se filtra EN CLIENTE por
 * presupuesto y nivel. Antes se pedia /collections/{handle}/products.json y se
 * cogian los 3 primeros, que con las colecciones en orden MANUAL (ranking de
 * merchandising) eran siempre las palas tope de gama -> el test enseñaba palas de
 * 390 € a quien habia pedido "hasta 100 €". products.json NO acepta parametros
 * filter.*, asi que el filtrado tiene que hacerse aqui.
 *
 * Accesible: role dialog + aria-modal, focus trap, cierre con Esc, teclado.
 * El modal se carga una vez de forma global; cualquier boton [data-phq-open] lo abre.
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function croot() {
    return ROOT.charAt(ROOT.length - 1) === '/' ? ROOT.slice(0, -1) : ROOT;
  }

  /* Tramos alineados con las colecciones reales de la tienda. */
  var TRAMOS = [
    { v: 'lte100', l: 'Hasta 100 €', min: 0, max: 100 },
    { v: '100200', l: '100 - 200 €', min: 100, max: 200 },
    { v: '200300', l: '200 - 300 €', min: 200, max: 300 },
    { v: 'gte300', l: 'Más de 300 €', min: 300, max: Infinity }
  ];

  function tramoDe(v) {
    for (var i = 0; i < TRAMOS.length; i++) {
      if (TRAMOS[i].v === v) return TRAMOS[i];
    }
    return null;
  }

  var QUESTIONS = [
    {
      key: 'nivel',
      title: '¿Cuál es tu nivel?',
      options: [
        { l: 'Iniciación', v: 'Iniciación' },
        { l: 'Intermedio', v: 'Intermedio' },
        { l: 'Avanzado', v: 'Avanzado' }
      ]
    },
    {
      key: 'estilo',
      title: '¿Qué estilo de juego prefieres?',
      options: [
        { l: 'Control', v: 'Control' },
        { l: 'Equilibrio', v: 'Equilibrio' },
        { l: 'Potencia', v: 'Potencia' }
      ]
    },
    {
      key: 'lesiones',
      title: '¿Sueles tener molestias de codo u hombro?',
      options: [
        { l: 'Sí', v: 'si' },
        { l: 'No', v: 'no' }
      ]
    },
    {
      key: 'presupuesto',
      title: '¿Qué presupuesto manejas?',
      options: TRAMOS.map(function (t) {
        return { l: t.l, v: t.v };
      })
    },
    {
      key: 'quien',
      title: '¿Para quién es la pala?',
      optional: true,
      options: [
        { l: 'Hombre', v: 'hombre' },
        { l: 'Mujer', v: 'mujer' },
        { l: 'Junior', v: 'junior' }
      ]
    }
  ];

  var ESTILO_BASE = {
    Control: 'palas-control',
    Equilibrio: 'palas-polivalentes',
    Potencia: 'palas-potencia'
  };
  var ESTILO_JUEGO = { Control: 'Control', Equilibrio: 'Polivalente', Potencia: 'Potencia' };

  var ESTILO_LABEL = { Control: 'Control', Equilibrio: 'Equilibrio', Potencia: 'Potencia' };
  var QUIEN_LABEL = { hombre: 'Hombre', mujer: 'Mujer', junior: 'Junior' };

  var MOSTRAR = 6;
  var MINIMO = 3;

  var state = { step: 0, answers: {} };
  var modal, dialog, inner, lastFocus;

  function euro(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(n);
    } catch (e) {
      return n.toFixed(2) + ' €';
    }
  }

  function compute(a) {
    var lesiones = a.lesiones === 'si';
    var quien = a.quien;
    var genderMode = false;
    var base;
    if (quien === 'mujer') {
      base = 'palas-mujer';
      genderMode = true;
    } else if (quien === 'junior') {
      base = 'palas-junior';
      genderMode = true;
    } else if (lesiones) {
      base = 'palas-control';
    } else {
      base = ESTILO_BASE[a.estilo] || 'palas-de-padel';
    }
    var juego = lesiones ? 'Control' : ESTILO_JUEGO[a.estilo];
    var tramo = tramoDe(a.presupuesto);
    var params = [];
    if (a.nivel) params.push('filter.p.m.specs.nivel=' + encodeURIComponent(a.nivel));
    if (genderMode && juego) params.push('filter.p.m.specs.juego=' + encodeURIComponent(juego));
    if (tramo) {
      if (tramo.min > 0) params.push('filter.v.price.gte=' + tramo.min);
      if (tramo.max !== Infinity) params.push('filter.v.price.lte=' + tramo.max);
    }
    var url = croot() + '/collections/' + base + (params.length ? '?' + params.join('&') : '');
    return {
      base: base,
      url: url,
      lesiones: lesiones,
      nivel: a.nivel || null,
      tramo: tramo,
      estiloLabel: lesiones ? 'control' : (ESTILO_LABEL[a.estilo] || '').toLowerCase()
    };
  }

  function renderStep() {
    var q = QUESTIONS[state.step];
    var total = QUESTIONS.length;
    var pct = Math.round(((state.step + 1) / total) * 100);
    var html =
      '<div class="phq__head">' +
      '<h2 class="phq__title" id="phq-title">Encuentra tu pala</h2>' +
      '<p class="phq__step">Paso ' + (state.step + 1) + ' de ' + total + (q.optional ? ' · opcional' : '') + '</p>' +
      '<div class="phq__progress" role="progressbar" aria-valuemin="1" aria-valuemax="' + total + '" aria-valuenow="' + (state.step + 1) + '">' +
      '<span class="phq__progress-bar" style="width:' + pct + '%"></span></div>' +
      '</div>' +
      '<div class="phq__q">' +
      '<h3 class="phq__question">' + q.title + '</h3>' +
      '<div class="phq__options" role="group" aria-label="' + q.title + '">';
    q.options.forEach(function (o) {
      var sel = state.answers[q.key] === o.v ? ' is-selected' : '';
      html += '<button type="button" class="phq__opt' + sel + '" data-phq-opt="' + o.v + '">' + o.l + '</button>';
    });
    html +=
      '</div></div>' +
      '<div class="phq__foot">' +
      (state.step > 0 ? '<button type="button" class="phq__btn phq__btn--ghost" data-phq-back>Atrás</button>' : '<span></span>') +
      (q.optional ? '<button type="button" class="phq__btn phq__btn--link" data-phq-skip>Saltar</button>' : '') +
      '</div>';
    inner.innerHTML = html;
    var first = inner.querySelector('.phq__opt');
    if (first) first.focus();
  }

  function tag(k, v) {
    return '<span class="phq__tag"><span class="phq__tag-k">' + k + '</span>' + v + '</span>';
  }

  function renderResult() {
    var a = state.answers;
    var r = compute(a);
    var tags = [];
    if (a.nivel) tags.push(tag('Nivel', a.nivel));
    if (a.estilo) tags.push(tag('Estilo', ESTILO_LABEL[a.estilo]));
    if (r.tramo) tags.push(tag('Presupuesto', r.tramo.l));
    if (a.quien) tags.push(tag('Para', QUIEN_LABEL[a.quien]));
    var html =
      '<div class="phq__head"><h2 class="phq__title" id="phq-title">Tu pala ideal</h2>' +
      '<p class="phq__step">Hemos preparado una selección para ti</p></div>' +
      '<div class="phq__result">' +
      '<div class="phq__tags">' + tags.join('') + '</div>' +
      (r.lesiones ? '<p class="phq__note">Hemos priorizado comodidad (palas de control, más blandas y tolerantes).</p>' : '') +
      '<div class="phq__preview" data-phq-preview hidden>' +
      '<p class="phq__preview-title" data-phq-preview-title>Tus palas</p>' +
      '<p class="phq__aviso" data-phq-aviso hidden></p>' +
      '<div class="phq__cards" data-phq-cards></div></div>' +
      '<div class="phq__cta">' +
      '<a class="phq__btn phq__btn--primary" href="' + r.url + '" data-phq-cta>Ver la colección completa</a>' +
      '<button type="button" class="phq__btn phq__btn--ghost" data-phq-restart>Repetir el test</button>' +
      '</div>' +
      '<form class="phq__save" data-phq-save novalidate>' +
      '<label class="phq__save-label" for="phq-email">Te la mando por correo con las tres que mejor te encajan</label>' +
      '<div class="phq__save-row">' +
      '<input type="email" id="phq-email" class="phq__input" placeholder="tu@email.com" autocomplete="email" required>' +
      '<button type="submit" class="phq__btn phq__btn--primary">Enviármela</button>' +
      '</div>' +
      '<label class="phq__consent">' +
      '<input type="checkbox" data-phq-consent>' +
      '<span>Acepto recibir mi recomendación y las novedades de PadelHouse. Puedo darme de baja cuando quiera.</span>' +
      '</label>' +
      '<p class="phq__save-msg" data-phq-save-msg hidden></p></form>' +
      '</div>';
    inner.innerHTML = html;
    loadPreview(r);
    var cta = inner.querySelector('[data-phq-cta]');
    if (cta) cta.focus();
  }

  /* --- Filtrado en cliente ------------------------------------------------ */

  /* Precio real del producto = el mas bajo de sus variantes. */
  function precioDe(p) {
    var min = Infinity;
    (p.variants || []).forEach(function (v) {
      var n = parseFloat(v.price);
      if (!isNaN(n) && n < min) min = n;
    });
    return min === Infinity ? null : min;
  }

  function disponible(p) {
    return (p.variants || []).some(function (v) {
      return v.available;
    });
  }

  function tieneNivel(p, nivel) {
    if (!nivel) return true;
    return (p.tags || []).indexOf('Nivel: ' + nivel) !== -1;
  }

  function enTramo(p, tramo) {
    if (!tramo) return true;
    var precio = precioDe(p);
    if (precio === null || precio <= 0) return false; // descarta los productos a 0 €
    return precio >= tramo.min && precio < tramo.max;
  }

  /**
   * Devuelve {items, aviso}. Relaja los criterios por pasos y SIEMPRE dice por que,
   * en vez de enseñar algo que no cumple sin avisar.
   */
  function seleccionar(pool, r) {
    var conStock = pool.filter(disponible);
    var base = conStock.length >= MINIMO ? conStock : pool;

    var exacto = base.filter(function (p) {
      return tieneNivel(p, r.nivel) && enTramo(p, r.tramo);
    });
    if (exacto.length >= MINIMO || (exacto.length && !r.tramo)) {
      return { items: exacto, aviso: '' };
    }

    // Paso 2: mismo nivel, ampliando SOLO al tramo contiguo (nunca a todo el
    // catalogo: eso reproduciria el bug original de enseñar palas de 350 € a
    // quien pidio 100 €). Ordenado de menor a mayor para que lo mas cercano al
    // presupuesto salga primero.
    if (r.tramo) {
      var idx = TRAMOS.indexOf(r.tramo);
      var vecino = TRAMOS[idx + 1] || TRAMOS[idx - 1];
      if (vecino) {
        var min = Math.min(r.tramo.min, vecino.min);
        var max = Math.max(r.tramo.max, vecino.max);
        var ampliado = base
          .filter(function (p) {
            var precio = precioDe(p);
            return (
              tieneNivel(p, r.nivel) && precio !== null && precio > 0 && precio >= min && precio < max
            );
          })
          .sort(function (a, b) {
            return precioDe(a) - precioDe(b);
          });
        if (ampliado.length >= MINIMO) {
          var arriba = TRAMOS[idx + 1] ? true : false;
          return {
            items: ampliado,
            aviso:
              'Solo tenemos ' + exacto.length + ' pala' + (exacto.length === 1 ? '' : 's') +
              ' de ' + r.estiloLabel + ' de tu nivel en ese presupuesto. Te enseñamos también ' +
              (arriba ? 'algunas hasta ' + max + ' €.' : 'algunas desde ' + min + ' €.')
          };
        }
      }
      // Paso 3: respetar el presupuesto y soltar el nivel.
      var soloPrecio = base.filter(function (p) {
        return enTramo(p, r.tramo);
      });
      if (soloPrecio.length) {
        return {
          items: soloPrecio,
          aviso:
            'No tenemos palas de ' + r.estiloLabel + ' de tu nivel en ese presupuesto. ' +
            'Estas entran en tu presupuesto aunque sean de otro nivel.'
        };
      }
    }

    if (exacto.length) return { items: exacto, aviso: '' };
    return { items: [], aviso: '' };
  }

  function pintarTarjeta(p) {
    var link = document.createElement('a');
    link.className = 'phq__card';
    link.href = croot() + '/products/' + p.handle;
    var img = p.images && p.images[0] && p.images[0].src ? p.images[0].src : '';
    if (img) {
      var im = document.createElement('img');
      im.className = 'phq__card-img';
      im.src = img;
      im.alt = p.title || '';
      im.loading = 'lazy';
      link.appendChild(im);
    }
    var t = document.createElement('span');
    t.className = 'phq__card-title';
    t.textContent = p.title || '';
    link.appendChild(t);
    var precio = precioDe(p);
    if (precio !== null) {
      var pr = document.createElement('span');
      pr.className = 'phq__card-price';
      pr.textContent = euro(precio);
      link.appendChild(pr);
    }
    return link;
  }

  function loadPreview(r) {
    var wrap = inner.querySelector('[data-phq-preview]');
    var cards = inner.querySelector('[data-phq-cards]');
    var avisoEl = inner.querySelector('[data-phq-aviso]');
    var titulo = inner.querySelector('[data-phq-preview-title]');
    if (!wrap || !cards) return;

    // limit=250 es el maximo del endpoint; la coleccion mas grande tiene ~56 palas,
    // asi que una sola llamada basta y el filtrado se hace aqui.
    var url = croot() + '/collections/' + r.base + '/products.json?limit=250';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('bad');
        return res.json();
      })
      .then(function (data) {
        var pool = (data && data.products) || [];
        if (!pool.length) return;

        var sel = seleccionar(pool, r);
        if (!sel.items.length) {
          if (titulo) {
            titulo.textContent =
              'No tenemos ninguna pala que cumpla todo lo que has pedido. Mira la colección completa o repite el test con otro presupuesto.';
          }
          wrap.hidden = false;
          return;
        }

        cards.textContent = '';
        sel.items.slice(0, MOSTRAR).forEach(function (p) {
          cards.appendChild(pintarTarjeta(p));
        });

        if (titulo) {
          var n = Math.min(sel.items.length, MOSTRAR);
          titulo.textContent = n === 1 ? 'Tu pala' : 'Tus ' + n + ' palas';
        }
        if (avisoEl && sel.aviso) {
          avisoEl.textContent = sel.aviso;
          avisoEl.hidden = false;
        }
        wrap.hidden = false;
      })
      .catch(function () {
        /* fallback graceful: sin preview, solo CTA */
      });
  }

  /* --- Navegacion del test ------------------------------------------------ */

  function next() {
    if (state.step < QUESTIONS.length - 1) {
      state.step++;
      renderStep();
    } else {
      renderResult();
    }
  }

  function back() {
    if (state.step > 0) {
      state.step--;
      renderStep();
    }
  }

  function onClick(e) {
    var opt = e.target.closest('[data-phq-opt]');
    if (opt) {
      state.answers[QUESTIONS[state.step].key] = opt.getAttribute('data-phq-opt');
      next();
      return;
    }
    if (e.target.closest('[data-phq-back]')) {
      back();
      return;
    }
    if (e.target.closest('[data-phq-skip]')) {
      state.answers[QUESTIONS[state.step].key] = null;
      next();
      return;
    }
    if (e.target.closest('[data-phq-restart]')) {
      state = { step: 0, answers: {} };
      renderStep();
      return;
    }
  }

  /* --- Captacion ----------------------------------------------------------
     Hasta el 2026-08-12 esto SOLO escribia en localStorage: el cliente dejaba
     su correo, veia "guardado en este navegador" y el dato moria ahi. No se
     creaba cliente ni habia forma de escribirle. Ahora se manda a Shopify con
     form_type=customer (el mismo mecanismo que ya usa el popup) y se etiqueta
     con las respuestas, que es lo que dispara el flow de recomendacion. */

  /* Los segmentos de Shopify comparan la etiqueta como cadena exacta, asi que
     las etiquetas van sin tildes ni espacios: "Iniciación" -> "iniciacion". */
  function slug(v) {
    return String(v || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function tagsDe(a) {
    var t = ['quiz'];
    if (a.nivel) t.push('quiz-nivel-' + slug(a.nivel));
    if (a.estilo) t.push('quiz-estilo-' + slug(a.estilo));
    if (a.presupuesto) t.push('quiz-presupuesto-' + slug(a.presupuesto));
    if (a.quien) t.push('quiz-para-' + slug(a.quien));
    if (a.lesiones === 'si') t.push('quiz-molestias');
    return t.join(',');
  }

  function onSubmit(e) {
    var f = e.target.closest('[data-phq-save]');
    if (!f) return;
    e.preventDefault();

    var input = inner.querySelector('#phq-email');
    var consent = inner.querySelector('[data-phq-consent]');
    var msg = inner.querySelector('[data-phq-save-msg]');
    var boton = f.querySelector('button[type="submit"]');
    var email = input ? input.value.trim() : '';

    function aviso(texto, esError) {
      if (!msg) return;
      msg.textContent = texto;
      msg.hidden = false;
      msg.classList.toggle('is-error', !!esError);
    }

    if (!email || email.indexOf('@') === -1) {
      aviso('Escribe un correo válido y te la mando.', true);
      if (input) input.focus();
      return;
    }
    if (consent && !consent.checked) {
      aviso('Marca la casilla para que pueda escribirte.', true);
      consent.focus();
      return;
    }

    /* El perfil sigue guardandose en local: sirve para reabrir el test con sus
       respuestas aunque el envio falle. */
    try {
      localStorage.setItem(
        'ph_quiz_profile',
        JSON.stringify({ answers: state.answers, email: email, ts: Date.now() })
      );
    } catch (_) {
      /* almacenamiento no disponible */
    }

    if (boton) {
      boton.disabled = true;
      boton.textContent = 'Enviando...';
    }

    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[accepts_marketing]', 'true');
    fd.append('contact[tags]', tagsDe(state.answers));

    fetch(croot() + '/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (res) {
        /* OJO: /contact responde HTML y devuelve 4xx cuando rechaza. Hay que
           mirar el estado. Dar la promesa por buena sin comprobarlo es el bug
           que arrastra ph-capture.js: enseña "listo" aunque no se guarde. */
        if (!res.ok) throw new Error('http-' + res.status);
        aviso('Hecho. Te llega en unos minutos.', false);
        if (boton) boton.textContent = 'Enviada';
      })
      .catch(function () {
        aviso('No hemos podido guardarlo. Inténtalo otra vez en un momento.', true);
        if (boton) {
          boton.disabled = false;
          boton.textContent = 'Enviármela';
        }
      });
  }

  function openModal(trigger) {
    lastFocus = trigger || document.activeElement;
    state = { step: 0, answers: {} };
    renderStep();
    // .is-open es el interruptor real de visibilidad/pointer-events (ver CSS).
    // hidden se mantiene por compatibilidad/accesibilidad.
    modal.hidden = false;
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown, true);
  }

  function closeModal() {
    modal.hidden = true;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKeydown, true);
    // Limpia el ancla al cerrar. Sin esto, el hash se queda en la URL y volver a
    // pulsar el mismo boton NO reabre el test: el navegador no dispara
    // 'hashchange' si el hash no cambia. replaceState no crea entrada de
    // historial, asi que el boton "atras" sigue funcionando como se espera.
    if (window.location.hash === '#test-pala') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
      return;
    }
    if (e.key === 'Tab') trapTab(e);
  }

  function trapTab(e) {
    var nodes = dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    var f = Array.prototype.filter.call(nodes, function (el) {
      return el.offsetParent !== null;
    });
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function init() {
    modal = document.querySelector('[data-phq]');
    if (!modal || modal.dataset.phqReady === '1') return;
    modal.dataset.phqReady = '1';
    dialog = modal.querySelector('[data-phq-dialog]');
    inner = modal.querySelector('[data-phq-inner]');
    inner.addEventListener('click', onClick);
    inner.addEventListener('submit', onSubmit);
    var close = modal.querySelector('[data-phq-close]');
    if (close) close.addEventListener('click', closeModal);
    var overlay = modal.querySelector('[data-phq-overlay]');
    if (overlay) overlay.addEventListener('click', closeModal);

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-phq-open]');
      if (t) {
        e.preventDefault();
        openModal(t);
      }
    });
  }

  /* Disparadores por URL -------------------------------------------------
     Ademas del click en [data-phq-open], el test se abre con:
       - ?quiz            (cualquier valor; se mantiene por compatibilidad)
       - #test-pala       (ancla: NO recarga la pagina si ya estas en ella)
     El ancla es lo que hace falta para el campo "Enlace" del editor: un enlace
     normal navegaria y recargaria; con # el modal salta al momento. */
  function abrirPorUrl() {
    var params = new URLSearchParams(window.location.search);
    if (params.has('quiz') || window.location.hash === '#test-pala') {
      openModal(null);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); abrirPorUrl(); });
  } else {
    init();
    abrirPorUrl();
  }
  window.addEventListener('hashchange', function () {
    if (window.location.hash === '#test-pala') openModal(null);
  });
  document.addEventListener('shopify:section:load', init);
})();
